import { getArchiveId } from 'modules/archive';
import {
    getCurrentInterview,
    getMediaStreamsForCurrentProject,
} from 'modules/data';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import MediaElement from '../media/MediaElement';
import {
    clearTimeChangeRequest,
    resetMedia,
    sendTimeChangeRequest,
    updateIsPlaying,
    updateMediaTime,
} from '../redux/actions';
import {
    getCurrentTape,
    getIsPlaying,
    getTimeChangeRequest,
    getTimeChangeRequestAvailable,
} from '../redux/selectors';

const mapStateToProps = (state) => ({
    archiveId: getArchiveId(state),
    interview: getCurrentInterview(state),
    mediaStreams: getMediaStreamsForCurrentProject(state),
    tape: getCurrentTape(state),
    isPlaying: getIsPlaying(state),
    timeChangeRequest: getTimeChangeRequest(state),
    timeChangeRequestAvailable: getTimeChangeRequestAvailable(state),
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            updateMediaTime,
            updateIsPlaying,
            resetMedia,
            sendTimeChangeRequest,
            clearTimeChangeRequest,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(MediaElement);
